import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ForwardIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", width = 24, height = 24, ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} width={width} height={height} {...rest}>
            <path d="M10.5185 21.2C6.58745 21.2 3.4 18.0216 3.4 14.1C3.4 10.1784 6.58745 7 10.5185 7H20V8.2H10.5185C7.24943 8.2 4.6 10.8419 4.6 14.1C4.6 17.3581 7.24943 20 10.5185 20V21.2Z" fill="currentColor"/>
            <path d="M19.7069 7.61844L16.0067 2.99326L16.9438 2.24362L21.2436 7.61844L16.9438 12.9933L16.0067 12.2436L19.7069 7.61844Z" fill="currentColor"/>
        </SvgIcon>
    );
};
